export default __webpack_public_path__ + "static/media/lightswitch_replicate0.4c384cca.svg";